import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import AppLayout from "../layouts/AppLayout";
import Product from "../components/Product";
import Pagination from "../components/Pagination";
import { Link } from '@inertiajs/react'
import Category from "../components/Category";
import Advantages from "../components/Advantages";
import Carousel from "../components/Carousel";


export default function Index({ products, title, categories, lastViewedProducts, popularProducts, user }) {

    return (
        <AppLayout>
            <div className="w-full">
                <div className="container max-w-dasha mx-auto px-4 sm:px-6 lg:px-8 py-10 lg:pt-0 flex flex-col space-y-7">
                    {/* <h2 className="text-3xl font-medium">{title}</h2>
                    <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-5">
                        {products ? products.data.map((product) => {
                            return <Product product={product} />
                        }) : null}
                    </div>

                    <div className="flex justify-center">
                        <Pagination page={products.current_page} total={products.last_page} route={'/'} />
                    </div> */}



                    <h2 className="text-3xl font-medium">Categories</h2>
                    <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-8">
                        {categories ? categories.map((category) => {
                            return (
                                <Category category={category} />
                            )
                        }) : null}
                    </div>

                    {popularProducts?.length > 0 ? (
                        <>
                            <h2 className="text-3xl font-medium">Popular products</h2>
                            <Carousel options={{ dragFree: true }} slides={popularProducts} />
                            {/* <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-5">
                                {popularProducts ? popularProducts.map((product) => {
                                    return <Product product={product} />
                                }) : null}
                            </div> */}
                        </>
                    ) : null}

                    {lastViewedProducts?.length > 0 ? (
                        <>
                            <h2 className="text-3xl font-medium">Last viewed products</h2>
                            <Carousel options={{ dragFree: true }} slides={lastViewedProducts} />
                            {/* <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-5">
                                {lastViewedProducts ? lastViewedProducts.map((product) => {
                                    return <Product product={product} />
                                }) : null}
                            </div> */}
                        </>
                    ) : null}


                    {/* <div className="flex justify-center">
                        @include('components.pagination', [
                'page' => $page,
                'total' => $total,
                'route' => Route::currentRouteName(),    
                'alias' => isset($category) ? $category->alias : null,
                        ])
                    </div> */}
                </div>
            </div>
            <hr />
            <Advantages />
            <hr />
        </AppLayout>
    )
}